import React from "react";
import {DropdownMenuItem, Text} from "@reside/ui";
import {connect} from "react-redux";
import {Dictionary} from "lodash";

import {select} from "../../../../store";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";
import {getResidentTestId} from "../../helper";
import {ModalName, useDashboardModalContext} from "../../DashboardModalContext";
import {AdmissionCardActionsMenu} from "./AdmissionCardActionsMenu";

type StateProps = Readonly<{
  isResideAdmin: boolean;
  isOrgAdmin: boolean;
  facilityFlagsById: Dictionary<{[key: string]: boolean}>;
}>;

type Props = Readonly<{
  admission: AdmissionFromSearch;
}>;

const PccReadmittedActionsRenderer = ({
  admission,
  isResideAdmin,
  isOrgAdmin,
  facilityFlagsById,
}: Props & StateProps) => {
  const {facilityId} = admission;
  const {toggleModal: toggleDeleteModal} = useDashboardModalContext(
    ModalName.CANCEL,
  );
  const {toggleModal: toggleForceDeleteModal} = useDashboardModalContext(
    ModalName.FORCE_DELETE,
  );

  const hasOrgAdminOnlyDeleteAdmissions =
    facilityFlagsById[facilityId]?.facilityHasOrgAdminOnlyDeleteAdmissions;
  const isDisabled = hasOrgAdminOnlyDeleteAdmissions ? !isOrgAdmin : false;

  return (
    <AdmissionCardActionsMenu
      testId={getResidentTestId(admission, "pccReadmittedCardActions")}
    >
      {isResideAdmin ? (
        <>
          <DropdownMenuItem
            onClick={() => !isDisabled && toggleDeleteModal(admission)}
            testId={getResidentTestId(admission, "deletePccPreflight-delete")}
            disabled={isDisabled}
          >
            <Text color="deepOrange100">Delete</Text>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => toggleForceDeleteModal(admission)}
            testId="force-delete-pcc-readmitted"
          >
            <Text color="deepOrange100">Force Delete</Text>
          </DropdownMenuItem>
        </>
      ) : (
        <DropdownMenuItem
          onClick={() => !isDisabled && toggleDeleteModal(admission)}
          testId={getResidentTestId(admission, "deletePccPreflight")}
          disabled={isDisabled}
        >
          <Text color="deepOrange100">Delete</Text>
        </DropdownMenuItem>
      )}
    </AdmissionCardActionsMenu>
  );
};

const mapStateToProps = (state: any): StateProps => ({
  isResideAdmin: select.adminSession.isResideAdmin(state),
  isOrgAdmin: select.adminSession.isOrgAdmin(state),
  facilityFlagsById: select.adminSession.facilityFlagsById(state),
});

export const PccReadmittedActions = connect(mapStateToProps)(
  PccReadmittedActionsRenderer,
);
